import React from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import LabeledEntry from "../../../helpers/LabeledEntry";
import { Button, Stack, styled } from "@mui/material";
import { testSessionLoader } from "../../../../loaders/helpers";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";
import {
  contactDelete,
  contactTextLongDescription,
  contactView,
} from "../../../../api/contact";
import ConfirmationContainer from "../../../helpers/ConfirmationContainer";

const StyledEntryContainer = styled(Stack)`
  gap: 1em;
  width: 80%;
  padding: 2em 0 4em;
`;

const StyledButtonContainer = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4em;
`;

const contactLoader = async (params) => {
  await testSessionLoader(params);
  const contactEntityId = params.params.id;
  const contactRes = await contactView(contactEntityId);
  const contact = contactRes.data;
  const longDescriptionRes = await contactTextLongDescription(
    contact.contactEntityId);
  const longDescription = longDescriptionRes.data;
  return { contact, longDescription };
};

const Contact = () => {
  const { contact, longDescription } = useRouteLoaderData("adminContact");
  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();

  const handleUpdateButtonClicked = () => navigate("update");
  const handleDeleteConfirmed = async () => {
    const res = await contactDelete(contact.contactEntityId);
    if (res.code === "SUCCESS") {
      infoSnackbar.alertSuccess(res.message);
      navigate(-1);
    } else {
      infoSnackbar.alertError(res.message);
    }
  };

  const placeholder = "Not Specified";

  return (
    <>
      <StyledEntryContainer>
        <LabeledEntry
          label="Request"
          value={contact.request}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Description"
          value={longDescription}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Name"
          value={`${contact.firstName} ${contact.lastName}`}
          placeholder={placeholder}
          link={contact.userEntityId
            ? `../../users/${contact.userEntityId}`
            : null}
        />
        <LabeledEntry
          label="Email"
          value={contact.email}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Phone"
          value={contact.phone}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Create Date"
          value={contact.createDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Last Modified"
          value={contact.modifyDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Status"
          value={contact.status}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Contact ID"
          value={contact.contactEntityId}
          placeholder={placeholder}
        />
      </StyledEntryContainer>
      <StyledButtonContainer>
        <Button
          variant="contained"
          onClick={handleUpdateButtonClicked}
        >
          Update
        </Button>
        <ConfirmationContainer
          dialogTitle="Confirm Contact Deletion"
          dialogMessage="Are you sure that you want to delete this contact?"
          onConfirmed={handleDeleteConfirmed}
        >
          <Button
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </ConfirmationContainer>
      </StyledButtonContainer>
    </>
  );
};

export { contactLoader };
export default Contact;